<div class="auth-hero-container">
    <div class="auth-hero-background"></div>
    <img alt="Powered By" class="powered-by-image" height="78" ngSrc="/assets/images/poweredby.svg" width="199" />
</div>
